import React from "react";

import { supportEmail, supportPhone } from "constants/agrinous";

export const AgrinousSupportPhoneLink = () => (
  <a href={`tel:${supportPhone}`}>{supportPhone}</a>
);

export const AgrinousSupportEmailLink = () => (
  <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
);
